import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate, useParams } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Products from "@/components/Products";
import Partners from "@/components/Partners";
import Clients from "@/components/Clients";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ServiceDetail from "@/components/ServiceDetail";
import ProductDetail from "@/components/ProductDetail";
import PartnersDetail from "@/components/PartnersDetail";
import { services, products } from "@/mock";

// Home Page Component
const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to section if specified in state
    if (location.state?.scrollTo) {
      const timeoutId = setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      return () => clearTimeout(timeoutId);
    }
  }, [location]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <Products />
        <Partners />
        <Clients />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  const LegacyServiceRedirect = () => {
    const { serviceId } = useParams();
    const service = services.find((item) => String(item.id) === String(serviceId));
    return <Navigate to={service ? `/services/${service.slug}` : "/"} replace />;
  };

  const LegacyProductRedirect = () => {
    const { id } = useParams();
    const product = products.find((item) => String(item.id) === String(id));
    return <Navigate to={product ? `/products/${product.slug}` : "/"} replace />;
  };

  return (
    <div className="App">
      <Toaster position="top-right" />
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services/:serviceSlug" element={<ServiceDetail />} />
            <Route path="/products/:productSlug" element={<ProductDetail />} />
            <Route path="/service/:serviceId" element={<LegacyServiceRedirect />} />
            <Route path="/product/:id" element={<LegacyProductRedirect />} />
            <Route path="/partners" element={<PartnersDetail />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
